import type { IAgCheckBoxCellRendererComponent } from 'components/AgGrid/AgCheckBoxCellRendererComponent';
import { AgCheckBoxCellRendererComponent } from 'components/AgGrid/AgCheckBoxCellRendererComponent';
import { Loader } from 'uikit';

import type React from 'react';

export const RatioRowsWithScopesSelectorCheckboxRenderer: React.FC<IAgCheckBoxCellRendererComponent> = (props) => {
    const { data, ...rest } = props;

    if (!data) {
        return <Loader />;
    }

    return <AgCheckBoxCellRendererComponent data={data} {...rest} />;
};

RatioRowsWithScopesSelectorCheckboxRenderer.displayName = 'RatioRowsWithScopesSelectorCheckboxRenderer';
